import React from 'react';
import { Card, CardContent, Typography, List, ListItem, ListItemButton, ListItemText, Chip, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface PendingReport {
  id: number;
  type: 'POST' | 'COMMENT' | 'USER';
  reason: string;
  createdAt: string;
  reporterName: string;
}

const typeLabels: Record<string, string> = { POST: '게시물', COMMENT: '댓글', USER: '사용자' };
const reasonLabels: Record<string, string> = {
  SPAM: '스팸',
  INAPPROPRIATE: '부적절',
  HARASSMENT: '괴롭힘',
  ILLEGAL: '불법',
  COPYRIGHT: '저작권',
  FALSE_INFO: '허위정보',
  ETC: '기타',
};

const timeAgo = (iso: string) => {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}분 전`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}시간 전`;
  return `${Math.floor(hrs / 24)}일 전`;
};

const PendingReportsList: React.FC<{ items: PendingReport[] }> = ({ items }) => {
  const navigate = useNavigate();
  return (
    <Card sx={{ flex: '1 1 400px', minWidth: 0 }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="h6">대기 중인 신고</Typography>
          <Button size="small" onClick={() => navigate('/reports?status=PENDING')}>
            전체 보기
          </Button>
        </Box>
        {items.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
            대기 중인 신고가 없습니다.
          </Typography>
        ) : (
          <List disablePadding>
            {items.map((r) => (
              <ListItem key={r.id} disablePadding>
                <ListItemButton onClick={() => navigate(`/reports/${r.id}`)}>
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                        <Chip label={typeLabels[r.type] || r.type} size="small" color="primary" variant="outlined" />
                        <Chip label={reasonLabels[r.reason] || r.reason} size="small" color="error" variant="outlined" />
                        <Typography variant="caption" color="text.secondary">
                          {timeAgo(r.createdAt)}
                        </Typography>
                      </Box>
                    }
                    secondary={`신고자: ${r.reporterName}`}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  );
};

export default PendingReportsList;
